// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__191v9","index":"styles_index__1Qn3G"};